import React from "react";
import { Alert } from "antd";

const SandboxBanner: React.FC = () => {
  return (
    <Alert
      message="SANDBOX ENVIRONMENT - Test Transactions Only"
      type="warning"
      showIcon
      banner
      style={{
        marginBottom: 24,
        textAlign: "center",
        fontWeight: "bold",
        backgroundColor: "#f59e0b",
        borderColor: "#f59e0b",
        color: "white",
      }}
    />
  );
};

export default SandboxBanner;
